import {ConfiguredElement, ProductElementModifier} from "../../providers/product/product-types";
import {RemoveButton} from "./RemoveButton";
import {Select} from "../inputs/Select";
import {SingleConfiguratorLine} from "./SingleConfiguratorLine";
import {TrashIcon} from "@heroicons/react/16/solid";
import {AddModifiersButton} from "./AddModifiersButton";
import React from "react";
import {useTranslation} from "react-i18next";

interface ConfiguratorValuesStateProps {
    index: number;
    totalConfigLength: number;
    config: ConfiguredElement;
    selectValues: string[];
    changeConfigType: (index: number, value: string) => void;
    changeConfigValue: (index: number, key: string, value: number | string) => void;
    onModifierRemove: (index: number, modifierIndex: number) => void;
    setState: (state: 'CONFIG' | 'DELETE' | 'MODIFIER') => void;
    possibleModifiers: ProductElementModifier[];
}

export const ConfiguratorValuesState = ({
                                            index,
                                            totalConfigLength,
                                            config,
                                            selectValues,
                                            changeConfigValue,
                                            changeConfigType,
                                            onModifierRemove,
                                            setState,
                                            possibleModifiers
                                        }: ConfiguratorValuesStateProps) => {
    const {t} = useTranslation();

    return (
        <div
            className="mt-8 mb-8 rounded-lg border-2 p-4 border-dashed border-gray-300 hover:border-gray-400">
            <div className={"flex-row flex justify-between"}>
                <h2 className={'mb-2'}>{t('CONFIG.ELEMENT')} {index + 1}</h2>
                {totalConfigLength !== 1 ? <div className={'flex flex-row gap-2'}>
                    {/*{index !== totalConfigLength - 1 ? <ArrowDownButton onClick={() => setState('DELETE')}/> : null}*/}
                    {/*{index !== 0 ? <ArrowUpButton onClick={() => setState('DELETE')}/> : null}*/}
                    <RemoveButton onClick={() => setState('DELETE')}/>
                </div> : null}
            </div>
            {selectValues.length !== 1 ?
                <Select title={t('CONFIG.TYPE')} value={config.config.title} values={selectValues}
                        onChange={(val) => changeConfigType(index, val)}/> : null}
            {config.config.params.map((e, i) => (
                <SingleConfiguratorLine key={i} index={index} element={e} config={config}
                                        changeConfigValue={changeConfigValue}/>
            ))}
            {config.modifiers.map((m, i) => (<div key={i}>
                <div className={'pt-1 pb-4'}>
                    <div className="relative mt-4">
                        <div aria-hidden="true" className="absolute inset-0 flex items-center">
                            <div className="w-full border-t border-gray-300"/>
                        </div>
                        <div className="relative flex items-center justify-between">
                            <span
                                className="bg-indigo-50 pr-3 text-sm font-semibold text-gray-900">{t('CONFIG.MODIFIER_' + m.name)}</span>
                            <button
                                onClick={() => onModifierRemove(index, i)}
                                type="button"
                                className="inline-flex items-center gap-x-1.5 rounded-full bg-indigo-50 px-3 py-1.5 text-sm font-semibold text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-gray-50"
                            >
                                <TrashIcon aria-hidden="true" className="-ml-1 -mr-0.5 size-5 text-gray-400"/>
                                <span>{t('BUTTON.REMOVE')}</span>
                            </button>
                        </div>
                    </div>
                    {m.params.map((modifierParam, modifierParamIndex) => (
                        <SingleConfiguratorLine key={modifierParamIndex} index={index} element={modifierParam}
                                                config={config}
                                                changeConfigValue={changeConfigValue}/>
                    ))}
                </div>
            </div>))}
            <AddModifiersButton modifiers={possibleModifiers} onClick={() => setState('MODIFIER')}/>
        </div>
    )
}